<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 17:58:06
-->
<template>
  <veStuMoralProgram viewType="my" slot="table"></veStuMoralProgram>
</template>

<script>
import veStuMoralProgram from './base/veStuMoralProgram';
export default {
  components: {
    veStuMoralProgram
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
